import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
})
export class RulesComponent implements OnInit {
  selectedRule: any;

  constructor() {
  }

  rulesClick(event: any, rule: any): void {
    this.selectedRule = rule;
  }

  ngOnInit(): void {
  }

}
